import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataContextService } from '../../shared/services/datacontext.service';
import { env } from '../../../environments/environment';

const contacts_api_url = env.API.contacts_api_url;

@Injectable({
  providedIn: 'root'
})
export class ContactsService extends DataContextService<any> {

  private apiUrl = contacts_api_url;


  constructor(http: HttpClient) {
    super(http, contacts_api_url);    
  }

  getData(): Observable<any> {    
    return this.get(this.apiUrl);
  }
}
